import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(7, 8, 6, 8),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(5, 3, 4, 3),
    },
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1.5),
    right: theme.spacing(1.5),
    color: theme.palette.text.secondary,
  },
  title: {
    ...theme.typography.h5,
    color: theme.palette.text.secondary,
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      fontSize: "1.6rem",
      marginBottom: theme.spacing(2.5),
    },
  },
  divider: {
    backgroundColor: theme.palette.grey[300],
    marginBottom: theme.spacing(4),
  },
  headline: {
    ...theme.typography.h6,
    color: theme.palette.text.secondary,
    fontWeight: 700,
    lineHeight: 1.35,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      fontSize: "1.2rem",
      marginBottom: theme.spacing(2.5),
    },
  },
  message: {
    ...theme.typography.body1,
    color: theme.palette.text.secondary,
    fontWeight: 400,
    lineHeight: 1.5,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
      marginBottom: theme.spacing(3),
    },
  },
  callRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    color: theme.palette.primary.main,
    [theme.breakpoints.down("md")]: {
      justifyContent: "flex-start",
      gap: theme.spacing(1),
    },
  },
  callIcon: {
    fontSize: "2rem",
  },
  callText: {
    ...theme.typography.h6,
    color: theme.palette.primary.main,
    fontWeight: 600,
    textDecoration: "none",
    lineHeight: 1.3,
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
}));

export default useStyles;
